import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../../@crema/utility/AppContext';
import { ThemeMode } from '../../constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import DesafioLogoBlanco from './updated-icon';
const AppLogo = () => {
  const { themeMode } = useContext(AppContext);
  const useStyles = makeStyles(() => ({
    logoRoot: {
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',
      alignItems: 'center',
    },
    logo: {
      height: 36,
      marginRight: 10,
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.logoRoot}>
      <Hidden smUp>

        <DesafioLogoBlanco className={classes.logo} />

      </Hidden>
      <Hidden xsDown>

        <DesafioLogoBlanco className={classes.logo} />

      </Hidden>
    </Box>
  );
};

export default AppLogo;
